<template>
  <transition name="dialog-wrap">
    <div class="dialog-box" v-if="isShow">
      <div class="dialog-wrap">
        <div class="paddingTop109"></div>
        <img
          @click="hide"
          class="close-img"
          src="/static/images/index/close_icon.png"
          alt=""
        />
        <div class="nav-wrap">
          <div
            :id="item.id"
            :name="item.name"
            @click="toPath(item.path)"
            class="nav-item"
            :class="path == item.path ? 'blackItem' : ''"
            v-for="item in navList"
            :key="item.label"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="cover" @click="isShow = false"></div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      path: "",
      isShow: false,
      navList: [
        {
          label: "关于我们",
          name: "“关于我们”按钮",
          path: "/aboutUs",
          id: "ID_AboutUs_Button",
        },
        {
          label: "新闻资讯",
          name: "“新闻资讯”按钮",
          path: "/newsList",
          id: "ID_News_Button",
        },
        {
          label: "加入我们",
          name: "“加入我们”按钮",
          path: "/joinUs",
          id: "ID_JoinUs_Button",
        },
        {
          label: "意见反馈",
          name: "“意见反馈”按钮",
          path: "/feedBack",
          id: "ID_Feedback_Button",
        },
        // {label: 'APP下载', path: '/'},
      ],
    };
  },
  mounted() {
    this.path = this.$route.path;
    console.log(this.path);
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    toPath(path) {
      this.hide();
      this.$router.push({
        path,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes myselfAnimation {
  from {
    height: 0;
  }
  to {
    height: 429px;
  }
}

.dialog-wrap-enter {
  margin-top: -320px;
}
.dialog-wrap-enter-active {
  transition: all 0.8s;
}

.dialog-wrap-leave-active {
  transition: all 0.8s;
}

.dialog-wrap-leave-to {
  margin-top: -320px;
  opacity: 0;
}

.dialog-box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  .cover {
    flex: 1;
  }
}
.dialog-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 310px;
  background: white;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // z-index: 999;
  padding: 0px 70px 20px 70px;
  // animation: myselfAnimation 0.8s;
  overflow: hidden;
  .paddingTop109 {
    height: 109px;
  }
  .close-img {
    width: 29px;
    height: 29px;
    position: absolute;
    top: 40px;
    right: 40px;
  }
  .nav-wrap {
    display: flex;
    flex-wrap: wrap;
    .nav-item {
      box-sizing: border-box;
      width: 285px;
      height: 60px;
      border-radius: 30px;
      border: 1px solid #000000; /*no*/
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000000;
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 40px;
    }
    .blackItem {
      color: #ffffff;
      background: #000000;
    }
    .nav-item:not(:nth-child(2n)) {
      margin-right: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue